import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link, useNavigate } from "react-router-dom";

const CardChip = () => (
  <svg width="38" height="28" viewBox="0 0 38 28" fill="none" aria-hidden="true">
    <rect
      x="0.5"
      y="0.5"
      width="37"
      height="27"
      rx="5.5"
      fill="url(#chip-grad)"
      stroke="#CB9CE0"
      strokeOpacity="0.4"
    />
    <path
      d="M13 0.5V10.5C13 12.5 11.5 14 9.5 14H0.5M13 27.5V17.5C13 15.5 11.5 14 9.5 14M25 0.5V10.5C25 12.5 26.5 14 28.5 14H37.5M25 27.5V17.5C25 15.5 26.5 14 28.5 14"
      stroke="#CB9CE0"
      strokeOpacity="0.45"
    />
    <defs>
      <linearGradient
        id="chip-grad"
        x1="0"
        y1="0"
        x2="38"
        y2="28"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4E7FF" stopOpacity="0.8" />
        <stop offset="1" stopColor="#CB9CE0" stopOpacity="0.5" />
      </linearGradient>
    </defs>
  </svg>
);

const ContactlessIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
    <path
      d="M5.5 7.5a7.5 7.5 0 0 1 0 7M9 5.5a11 11 0 0 1 0 11M12.5 3.5a14.5 14.5 0 0 1 0 15"
      stroke="#CB9CE0"
      strokeOpacity="0.55"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-dark-background-main relative min-h-screen overflow-hidden">
      <img
        src="/images/bg-logo.svg"
        alt=""
        className="fixed right-2/5 bottom-[calc(50%-100px)] z-0 translate-x-1/2 translate-y-1/2 opacity-40"
      />

      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4 py-12">
        <img
          src="/images/full-logo.svg"
          className="mb-10 w-28"
          alt="Vaulta"
        />

        <div className="relative mb-10">
          <div
            className="absolute top-1/2 left-1/2 h-40 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full opacity-30 blur-3xl"
            style={{
              background:
                "radial-gradient(closest-side, #cb9ce0 0%, transparent 100%)",
            }}
            aria-hidden="true"
          />

          <div className="notfound-float relative h-44 w-72 sm:h-48 sm:w-80">
            <div className="border-dark-stroke-3 relative h-full w-full overflow-hidden rounded-2xl border bg-white shadow-[0_24px_48px_-12px_rgba(0,0,0,0.15),inset_0_1px_0_rgba(255,255,255,0.6)]">
              <div
                className="pointer-events-none absolute inset-0"
                style={{
                  background:
                    "linear-gradient(115deg, transparent 30%, rgba(203, 156, 224, 0.1) 45%, rgba(203, 156, 224, 0.04) 55%, transparent 70%)",
                }}
                aria-hidden="true"
              />
              <div
                className="pointer-events-none absolute -top-10 -right-10 size-32 rounded-full opacity-20 blur-2xl"
                style={{ background: "#cb9ce0" }}
                aria-hidden="true"
              />

              <div className="relative flex h-full flex-col justify-between p-5">
                <div className="flex items-start justify-between">
                  <CardChip />
                  <ContactlessIcon />
                </div>

                <p className="text-dark-text-400 font-mont text-lg font-semibold tracking-[0.2em] sm:text-xl">
                  4040 0404 4040
                </p>

                <div className="flex items-end justify-between">
                  <div>
                    <p className="text-dark-text-300 text-[9px] tracking-[0.25em] uppercase">
                      Cardholder
                    </p>
                    <p className="text-dark-text-400 text-xs font-medium tracking-widest uppercase">
                      Page Not Found
                    </p>
                  </div>
                  <div className="flex" aria-hidden="true">
                    <span className="bg-dark-primary-main/40 size-6 rounded-full" />
                    <span className="bg-dark-primary-main/20 -ml-2.5 size-6 rounded-full" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-dark-text-400 text-center">
          <p className="text-dark-text-300 mb-2 text-xs font-medium tracking-[0.3em] uppercase">
            Error 404
          </p>
          <h1 className="mb-3 text-2xl font-semibold sm:text-3xl">
            Page not found
          </h1>
          <p className="text-dark-text-300 mx-auto mb-8 max-w-md text-sm leading-5">
            The link you followed doesn't point to anything here. It may have
            been moved, or it never existed in the first place.
          </p>

          <div className="flex flex-col justify-center gap-3 sm:flex-row">
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              size="sm"
              className="border-dark-stroke-3 text-dark-text-400 w-full justify-center sm:w-auto"
            >
              <ArrowLeft className="size-4" />
              Go Back
            </Button>
            <Button asChild size="sm" className="w-full sm:w-auto">
              <Link to="/dashboard" className="justify-center">
                Go to Dashboard
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
